import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  carouselImg: {
    height: 'calc(100vh - 64px)',
    minWidth: '100vw !important',
    objectFit: 'cover',
  }
}));
